// START Open Requre.JS wrapper
define([
    'jquery',
    'domReady',
	'shared.main.screen',
    'wcs.product-form-util',
    "pubsub"
    ], function ( $, domReady, screenSize ){
// END Open Require.JS wrapper

/****
 * PDP Swatches product event handlers - AKA NEW PDP -- used in all brands except Vans and TBL
 ***/

	var DEBUG = false,
		EVENT_DEBUG = false,
		PLUGIN_IDENTIFIER = 'PDPSwatchesEvents',
		isDataColorway = $('body.pdp-drawer, .quickview-box.pdp-drawer').length || false,
		updatePriceOnColorSwatchHover = WCS_CONFIG.get('PDP::pdpUpdatePriceOnColorSwatchHover') === true,
		pdpUpdateColorTextOnHoverDisabled = WCS_CONFIG.get('PDP::pdpUpdateColorTextOnHoverDisabled') === true,
		pdpUseInlineErrorEnabled = WCS_CONFIG.get("PDP::pdpUseInlineErrorEnabled") || false,
		pdpDefaultSelectOnRegularSizeButton = WCS_CONFIG.get("PDP::pdpDefaultSelectOnRegularSizeButton") || false, 
		regularSizeSelected = false;

	/** product form class **/
	var PDPSwatchesEvents = function (productForm) {

		if (!(this instanceof PDPSwatchesEvents)) {
			return new PDPSwatchesEvents(productForm);
		}
		
		this.productForm = $(productForm);  // .product-form-js element
		this.productFormIndex = $('.product-form-js').index(this.productForm);
		
		return this;
	};

	PDPSwatchesEvents.prototype = {
		
		initPDPSwatchesEvents : function () {

			if ( DEBUG ) console.log('initializing PDP Swatches Events');

			this.globalEvents();
			this.PDPSwatchesEvents();

			return this;
		},

		globalEvents : function () {
			var self = this;
			$(document).on( 'QUICKSHOP_DISPLAY', 'REFRESH_PRODUCT_AVAILABILITY', function(e) {
	    		if ( EVENT_DEBUG ) console.log('QUICKSHOP_DISPLAY', 'REFRESH_PRODUCT_AVAILABILITY');
	    		self.PDPSwatchesEvents();
	    	});

			$.pubsub('subscribe', 'WCS.PRODUCTFORM.COLORWAY_PRODUCT.FORM_UPDATE',  function() {
				self.PDPSwatchesEvents();
			});

		},

		isSizeButtonClick: function(event){
			return $(event.currentTarget).hasClass('product-content-form-size-btn-label');
		},

		// DOM EVENTS
		PDPSwatchesEvents : function () {

			if ( DEBUG ) console.log('PDPSwatchesEvents');
			
			var self = this,
				isMouseOrTouchEvent	= this.touchType = window.navigator.pointerEnabled ? "pointer" :
                           		"ontouchstart" in window ? "touch" : "mouse";

			this.productForm.find('select').off('change');

			this.productForm.find('select').on('change', function(event){
				if ( EVENT_DEBUG ) console.log('product form select change');
				$.pubsub('publish', 'WCS.PRODUCTFORM.ATTRIBUTE.CHANGE');
				self.handleSelectAttributeChange(event);
				self.resetFormErrors();	
			});

			this.productForm.find('.attr-box').not('.context-trigger-js, .bl-attr-box').on({
				click: function(event){
					event.preventDefault();
					// make sure we have the button/swatch that
					// we can pass along
					var obj = {target: event.currentTarget};
					
					if ( EVENT_DEBUG ) console.log('attr-box mouse click');
					self.handleFormClick(obj, self);

					if ( DEBUG ) console.log('publishing : WCS.PRODUCTFORM.COLORWAY_PRODUCT.UPDATE');
					$.pubsub('publish', 'WCS.PRODUCTFORM.COLORWAY_PRODUCT.UPDATE', data = {formIndex : self.productFormIndex, object : $(obj.target) });
					
					if ( DEBUG ) console.log('publishing : WCS.PDPSWATCHES.PRODUCTFORM.EVENT.FORMCLICK');
					// generic form attribute click, swatch, size, etc. - pass boolean true
					$.pubsub('publish', 'WCS.PDPSWATCHES.PRODUCTFORM.EVENT.FORMCLICK', true);
					$.pubsub('publish', 'PDP_ADD_TO_CART_SELECTED', obj);
				},
				mouseenter: function(event){
					// make sure we have the button/swatch that
					// we can pass along
					var obj = {target: event.currentTarget};
					if ( isMouseOrTouchEvent === 'touch' ) {
						return false;
					}
					if ( EVENT_DEBUG ) console.log('attr-box mouseenter');
					if ( $('body.catalog.bundle, body.catalog.bundle-detail-page-js').length > 0 ){
						return;
					}
					if (pdpUpdateColorTextOnHoverDisabled && !self.isSizeButtonClick(event)) {
						return;
					}
                    self.handlePDPSwatchesAttributeSelection(obj, self, {updateItemPrice: updatePriceOnColorSwatchHover, originateFromClick: false});
					if ( DEBUG ) console.log('publishing : WCS.PRODUCTFORM.EVENT.ATTR.MOUSE.ENTER');
					$.pubsub('publish', 'WCS.PRODUCTFORM.EVENT.ATTR.MOUSE.ENTER', $(obj.target));
				},
				mouseleave: function(event){
					// make sure we have the button/swatch that
					// we can pass along
					var obj = {target: event.currentTarget};
					if ( isMouseOrTouchEvent ==='touch' ) {
						return false;
					}
					if ( EVENT_DEBUG ) console.log('attr-box mouse leave');
					if ( $('body.catalog.bundle, body.catalog.bundle-detail-page-js').length > 0 ){
						return;
					}
					if (pdpUpdateColorTextOnHoverDisabled && !self.isSizeButtonClick(event)) {
						return;
					}
					self.handleFormMouseLeave(obj);
					if ( DEBUG ) console.log('publishing : WCS.PRODUCTFORM.EVENT.ATTR.MOUSE.LEAVE');
					$.pubsub('publish', 'WCS.PRODUCTFORM.EVENT.ATTR.MOUSE.LEAVE', $(obj.target));					
				},
				focus: function(event){
					// make sure we have the button/swatch that
					// we can pass along
					var obj = {target: event.currentTarget};
					if ( EVENT_DEBUG ) console.log('attr-box focus');
                    self.handlePDPSwatchesAttributeSelection(obj, self, {updateItemPrice: updatePriceOnColorSwatchHover, originateFromClick: false});
					if ( DEBUG ) console.log('publishing : WCS.PRODUCTFORM.EVENT.ATTR.MOUSE.ENTER');
					$.pubsub('publish', 'WCS.PRODUCTFORM.EVENT.ATTR.MOUSE.ENTER', $(obj.target));
				},
				blur: function(event){
					// make sure we have the button/swatch that
					// we can pass along
					var obj = {target: event.currentTarget};
					if ( EVENT_DEBUG ) console.log('attr-box blur');
					self.handleFormMouseLeave(obj);
					if ( DEBUG ) console.log('publishing : WCS.PRODUCTFORM.EVENT.ATTR.MOUSE.LEAVE');
					$.pubsub('publish', 'WCS.PRODUCTFORM.EVENT.ATTR.MOUSE.LEAVE', $(obj.target));					
				}				
			});


			if (isDataColorway){
				// bind attr-box to parent container to retain event after size reloads
				$('.step-container.attr-size').on('click','.attr-box', function(event){
					// make sure we have the button/swatch that
					// we can pass along
					var obj = {target: event.currentTarget};
					self.handleFormClick(obj, self);

					if( $('.step-content-width').find(event.currentTarget).length === 0 ){
						self.lastSelectedSize = event.currentTarget;
						self.lastSelectedValue = $(event.currentTarget).data('attributeValue');
					}
					else{
						var lastSelected = $(event.currentTarget).data('attributeValue');
						if( lastSelected !== self.lastSelectedWidthValue){
							self.lastSelectedWidthValue = lastSelected;
							$.pubsub('publish', 'WCS.PDPSWATCHES.PRODUCTFORM.EVENT.SIZESELECTED', {lastSelectedWidthValue: self.lastSelectedWidthValue});
						}
					}
				});

				// unbind mouseenter/mouseleave
				this.productForm.find('.attr-box').not('.context-trigger-js').off('mouseenter mouseleave focus blur');			
			}

			// PDP swatch change event
			var selectorSwatches = $('.color-swatches-js .attr-box').not('.bl-attr-box');

            selectorSwatches.on('click', function(event, extraParameters) {
            	if ( EVENT_DEBUG ) console.log('attr swatch click');
				// TODO: Data should be moved to the button instead of the inner image
				var selector = '[data-variation-id]';
				var scope = event.currentTarget;

				// make sure we have the button/swatch that
				// we can pass along
				var obj = {
					target: scope
				};

				// Firefox will return the button for event.target but 
				// Chrome will return the image. This will normalize and always get back
				// the image element with the data attribute, regardless if it was the target or
				// the child of the target.
				var obj2 = {
					target: $(selector, scope).addBack(selector, scope)[0]
				};

                if (extraParameters) {
                    obj2 = $.extend( {}, obj2, extraParameters );
                }

                if (isDataColorway){
                    self.newColorWayProductEvent(obj2, self);
                }
				
				$.pubsub('publish', 'product-form.attr.swatch.click', obj2);
				$.pubsub('publish', 'WCS.PDPSWATCHES.PRODUCTFORM.EVENT.FORMCLICK');
				self.handlePDPSwatchClick(obj, self);
			});

			this.pdpSwatchesWindowResizeEventToken = $.pubsub('subscribe', 'window.resize', function(){
				if ( EVENT_DEBUG ) console.log('product form window resize');
				self._handleWindowResize();
			});

			//toggle product detail drawers on swatches layout
			$('.pdp-swatches .product-details-js > h3').on('click', self._handleProductDetailsJSClick );
			$('.age-verify-js').on('click', function(){
                selectorSwatches.trigger('click');
			});

			// Pre select the "Regular" size button when it is not a preSelectedProduct
			if (pdpDefaultSelectOnRegularSizeButton) {
				$.pubsub('subscribe', 'WCS.PRODUCTFORM.PRESELECTED_VALUES.INIT',  function(event, isPreselected) {
					if (!isPreselected && !regularSizeSelected) {
						regularSizeSelected = true; // Prevent this to run multiple times
						var $regularSizeButton = $('.attr-size.selection-js').find('.attr-box.large[data-attribute-value="Regular"]');
						if ($regularSizeButton.length > 0) {
							$regularSizeButton.click();
						}
					}
				});
			}


			$.pubsub('subscribe', 'WCS.PRODUCTFORM.PRESELECTED_VALUES.INIT',  function(event, isPreselected) {
				var pdpFormUpdateDefaultSelectionL1 = WCS_CONFIG.get('PDP::pdpFormUpdateDefaultSelectionL1');

				if( self.lastSelectedWidthValue && pdpFormUpdateDefaultSelectionL1 ) {
					var $sizeSelection = $('.attr-size.selection-js');
					var $lastSelectedWidthButton = $sizeSelection.find('button:not(.clicked)button:not(.out-of-stock).attr-box[data-attribute-value="' + self.lastSelectedWidthValue + '"]');

					if ($lastSelectedWidthButton.length > 0) {
						$lastSelectedWidthButton.click();
					}
				}

				if( self.lastSelectedSize && self.lastSelectedValue && pdpFormUpdateDefaultSelectionL1 ){
					var $lastSelectedButton = $('.attr-size.selection-js').find('button:not(.clicked).attr-box[data-attribute-value="'+ self.lastSelectedValue + '"]');
					if ($lastSelectedButton.length > 0) {
						$lastSelectedButton.click();
					}
				}
			});
		},

		handleSelectAttributeChange : function (event) {

        	if ( DEBUG ) console.log('handleSelectAttributeChange');
  
			var $obj = $(event.target).find(':selected').eq(0),
				isAttribute = $obj.attr('data-attribute-value') || $obj.parent().attr('data-attribute-value'), 
				$parentSection, $tagElem, attribute, attributeValue, colorIdentifier, subAttrValue, attrLongValue;

			if ( $obj.hasClass('attr-size-deselected-js') ) {
				$.productFormUtil.resetSizeOptions($obj, this.productFormIndex);
			}
  
			if ( !isAttribute ) {
				return false;
			}

			$parentSection  = $obj.parents('.selection-js');
			$tagElem        = $obj.data('attribute-value') ? $obj : $obj.parent();
			attribute 		= $parentSection.attr('data-attribute-id');
			attributeValue  = $tagElem.attr('data-color-identifier') || $tagElem.attr('data-attribute-value');

			// Strip off the `selected` class from all the options
			$obj.siblings().removeClass('selected');
			// Add the `selected` class to the one that is actually selected
			$obj.addClass('selected');

			$parentSection.toggleClass("attribute-value-selected", true);
			if ( EVENT_DEBUG ) console.log('publishing : WCS.PRODUCTFORM.ATTRIBUTE.CHANGE.COMPLETE');
			$.pubsub('publish', 'WCS.PRODUCTFORM.ATTRIBUTE.CHANGE.COMPLETE', data = {obj : $obj, attribute : attribute, attributeValue : attributeValue, formIndex: this.productFormIndex });
			// this is subscribed to within product form core and product price
			
		},
		
		handleFormClick : function(e, self) {

			if ( DEBUG ) console.log('handleFormClick', e);
			
			var $button = $(e.target),
				$siblings = $button.parent('.attr-container-js').find('.attr-box');

			$siblings.removeClass('selected clicked');
			$button.addClass('selected clicked');

			self.handlePDPSwatchesAttributeSelection( e, self, {originateFromClick: true} );
			
			if(pdpUseInlineErrorEnabled) {
				self.handleHideInlineErrorMessageOnAttributeChange($button);
			}
		},

		handleFormMouseLeave : function(e) {
			
			var $this = $(e.target),
				$clickedSibling = null,
				$parentSection  = $this.parents('.selection-js'), 
				$attrConversionValue = '';
			
			$this = $this.attr('data-role') ? $this.parent() : $this;
			
			$clickedSibling = $this.siblings('.clicked');
			
			if (!$this.hasClass('clicked')){
				$clickedSibling.addClass('selected');
				$this.removeClass('selected');

				if (!$clickedSibling.length){
					$this.parents('.selection-js').removeClass('attribute-value-selected');

					// reset label
					$parentSection.find('.attribute-label-value-js').html('');
				} else {
					// show  label
					$attrConversionValue = $clickedSibling.data('attributeValue');
					var colorNumber = $clickedSibling.data('colorIdentifier');
					var fabricAttribute = $clickedSibling.data('subAttributeValue');

					if ( $attrConversionValue ){
						$parentSection.find('.attribute-label-value-js').html( $attrConversionValue );
					}
					if (colorNumber) {
						$parentSection.find('.attr-selected-color-identifier').html('(' + colorNumber + ')');
					}
					if (fabricAttribute) {
						$parentSection.find('.sub-attr-selected-js').html(fabricAttribute);
					}

				}
			}
		},

		handleHideInlineErrorMessageOnAttributeChange: function($attr) {
			var $inlineErrorMessage = $attr.parents('.attr-size.selection-js').find('.select-size-error-js');
			$inlineErrorMessage.addClass('hide');
		},

		_handleProductDetailsJSClick : function ( event ) {
		
			var $this = $(this);
		
			if (screenSize.size() === 'small'){
		
				$this.parent().children('.inner-content').slideToggle('fast');
				$this.children('span').toggleClass('open');
		
			}
		
		},

		_handleWindowResize : function () {
			var _scrollbarSize  = $.productFormUtil.getScrollbarSize(),
				width 			= $(window).width() + _scrollbarSize;

			//fix display prod detail when resize from mobile to larger screen
			if ( $('.pdp-swatches').length && (screenSize.size() !== 'small')){
 				$('.product-details-js .inner-content').css('display','block');
				$('.product-details-js h3 span').removeClass('open');
			}
			
		},

		handlePDPSwatchesAttributeSelection: function (event, self, options) {

			if ( DEBUG ) console.log('handlePDPSwatchesAttributeSelection');
			var $obj = $(event.target),
			$parentSection, $tagElem, attribute, attributeValue, colorIdentifier, subAttrValue, attrLongValue, attrConversionValue, itemStockAttributeValue, $shareSubHeading;

			self.resetFormErrors(event);
			
			if ( $obj.data('attribute-value') !== 'undefined' || $obj.parent().data('attribute-value') !== 'undefined' ) {

				$parentSection  = $obj.parents('.selection-js');
				$tagElem 		= $obj.data('attribute-value') !== 'undefined' ? $obj : $obj.parent();
				colorIdentifier = $tagElem.attr('data-color-identifier');
				subAttrValue 	= $tagElem.attr('data-sub-attribute-value');
				attrLongValue 	= $tagElem.attr('data-attribute-long-value');
				attrConversionValue = $tagElem.attr('data-attribute-conversion-value');
				attribute 		= $parentSection.attr('data-attribute-id');
				attributeValue  = colorIdentifier || $tagElem.attr('data-attribute-value');
				itemStockAttributeValue  = $tagElem.attr('data-attribute-stock');
				$shareSubHeading = $('.social-media-share-modal-subheading');

				var $attributeLabelValue = $parentSection.find ('.attribute-label-value-js');
				if ( attrConversionValue ){
					$attributeLabelValue.html( attrConversionValue );
				} else {
					if (attrLongValue) {
						$attributeLabelValue.html (attrLongValue);
						$parentSection.find ('.attribute-label-separator-js').show();
					} else {
					    if( pdpUpdateColorTextOnHoverDisabled ){
                            if( options.originateFromClick ){
                                $attributeLabelValue.html ($tagElem.data('attribute-value'));
                            }
                        }
					    else{
                            $attributeLabelValue.html ($tagElem.data('attribute-value'));
                        }

						$parentSection.find ('.attribute-label-separator-js').show();
					}

					if (colorIdentifier && !$('.full-attr-color-select').length) {
						$parentSection.find ('.attr-selected-color-identifier').html (' (' + colorIdentifier + ')');
					}

					if (subAttrValue) {
						$parentSection.find ('.sub-attr-name').show();
						$parentSection.find ('.sub-attr-selected').html ( subAttrValue);
					} else{
						$parentSection.find ('.sub-attr-name').hide();
					}
				}

				$parentSection.find('.step-content .selected').removeClass('selected');
				$tagElem.toggleClass('selected', true);

				if ($tagElem.prop ('tagName') !== 'OPTION'){
					$parentSection.find ('.attr-container input:checked').prop ('checked', false);
					$parentSection.find ('#' + $tagElem.data ('formButton')).prop ('checked', true);
				}

				// update sharing product name
				var $productName = $tagElem.find('img').data('productName');
				if($shareSubHeading.length && $productName){
					$shareSubHeading.html($productName);
				}

				// normal attribute
				$parentSection.toggleClass("attribute-value-selected", true);
				
				if ( EVENT_DEBUG ) console.log('publishing : WCS.PRODUCTFORM.ATTRIBUTE.CHANGE.COMPLETE');
                var data = {
                    obj: $obj,
                    formIndex: this.productFormIndex,
                    attribute: attribute,
                    attributeValue: attributeValue,
                    itemStockAttributeValue: itemStockAttributeValue,
                    updateItemPrice: true
                };
                if (options) {
                    data = $.extend({}, data, options);
                }
                $.pubsub('publish', 'WCS.PRODUCTFORM.ATTRIBUTE.CHANGE.COMPLETE', data);
			}
		
		},

		/**
		 * resetFormErrors()
		 *
		 * Resets any errors that were triggered on form elements
		 * 
		 */
		resetFormErrors : function () {

			if ( DEBUG ) console.log('resetFormErrors');
			
			$(".select-quantity-error-js", this.productForm).addClass("hide");
			$("#qty-step-container", this.productForm).removeClass("error");

			this.resetCartErrors();
		},

		/**
		 * resetCartErrors()
		 *
		 * Resets any errors that were triggered after a user
		 * tried adding a product to their cart
		 * 
		 */
		resetCartErrors : function () {

			if ( DEBUG ) console.log('resetCartErrors');

			$.productFormUtil.clearAddTOCartErrorMessage(this.productForm);
		},
		
		handlePDPSwatchClick : function (event, self) {

			if ( DEBUG ) console.log('handlePDPSwatchClick');

			var $target = $(event.target);

			$target.addClass('clicked')
				.siblings()
				.removeClass('clicked');

            var swatchModelMeasurement = $target.find('.color-swatch-button-content').data('modelMeasurement');
            var modelMeasurementText = '';
            if(swatchModelMeasurement) {
				modelMeasurementText = swatchModelMeasurement.replace(/\$\$/g, '<br/>');
				modelMeasurementText += '<br/>';
			}
            this.productForm.find('.model-measurements-text').html(modelMeasurementText);

			self.handlePDPSwatchesAttributeSelection( event, self, {originateFromClick: true} );
		},

		newColorWayProductEvent : function (event, self){
            var $obj = $(event.target),
                dataProductId = $obj.data('productId');
            if (dataProductId) {
                $('input[name=catEntryId]').val(dataProductId);
            }

            $.pubsub('publish', 'WCS.PRODUCTFORM.COLORWAY_PRODUCT.NEW', data = {formIndex : self.productFormIndex, object : $obj });
		}

	}; /** end product form class **/
	
	// prevent duplicate instantiation
	$.fn.PDPSwatchesEvents = function() {
		return this.each(function() {
			var instance = $(this).data(PLUGIN_IDENTIFIER);
			if(!instance) {
				instance = new PDPSwatchesEvents(this).initPDPSwatchesEvents();
				$(this).data(PLUGIN_IDENTIFIER,instance);
			}
		});
	};

// START close Require.JS wrapper		
	}
);
// END close Require.JS wrapper
